// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-info-message {
    box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);
    border-radius: 4px;
    max-width: 65%;
    overflow-wrap: break-word;
    padding: 10px 10px;
    margin: 5px;
    min-width: 100% !important;
    height: auto;
    background-color: rgba(185, 196, 196, 0.4);
    font-size: 1.6rem;
    margin-top: 2rem;
    box-sizing: border-box;
    min-height: 2rem;
}

.chat-info-message__flex-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
}

.chat-info-message.chat-type-comment {
    background-color: rgba(156, 247, 171, 0.4);
}

.chat-info-message.chat-type-group {
    background-color: rgba(170, 156, 247, 0.4);
}

.chat-info-message.chat-type-mailing {
    background-color: rgba(247, 218, 156, 0.4);
}

button.chat-info-message__chat-summary-button {
    flex-shrink: 0;
    font-size: 1.5rem;
    gap: 1rem;
    color: #039be5;
    background-color: transparent;
    display: flex;
    align-items: center;
    align-self: center;
    white-space: nowrap;
    position: static;
    height: auto;
    background: linear-gradient(90deg,rgba(227, 231, 231, 1) 70%, rgba(65, 180, 230, 0.14) 100%, rgba(227, 231, 231, 1) 100%);
}

    button.chat-info-message__chat-summary-button:focus {
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
        background-color: transparent;
    }

    button.chat-info-message__chat-summary-button:hover {
        background: linear-gradient(90deg,rgba(227, 231, 231, 1) 70%, rgba(65, 181, 230, 0.24) 100%, rgba(227, 231, 231, 1) 100%);
    }

.summary-header-title-wrapper {
    display: flex;
    gap: 1.6rem;
    align-items: center;
}

.summary-header__close-button-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
}

    .summary-header__close-button-wrapper button {
        margin-right: 1.8rem;
    }

.summary-modal.modal-dialog {
    max-width: 65%;
    min-width: 65%;
    overflow: hidden;
}

.summary-modal .modal-title {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    font-size: 3.6rem;
}

.summary-body__summary-text {
    white-space: pre-line;
    text-align: justify;
}

.summary-header-wrapper {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    max-height: 15vh;
}

.summary-body-wrapper {
    max-height: 65vh;
    overflow-y: auto;
    padding: 0 10px 0 0;
}

.summary-footer-wrapper {
    max-height: 0;
}

.chat-info-message__content {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-width: 0;
}

.chat-info-message__channel-row,
.chat-info-message__chat-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    width: 100%;
    min-width: 0;
}

.chat-info-message__channel-name {
    max-width: 50rem;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/chat/chat-info-message/ChatInfoMessageItem.css"],"names":[],"mappings":"AAAA;IACI,uGAAuG;IACvG,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,0BAA0B;IAC1B,YAAY;IACZ,0CAA0C;IAC1C,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,WAAW;AACf;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,SAAS;IACT,cAAc;IACd,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,yHAAyH;AAC7H;;IAEI;QACI,+GAA+G;QAC/G,6BAA6B;IACjC;;IAEA;QACI,yHAAyH;IAC7H;;AAEJ;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;IAEI;QACI,oBAAoB;IACxB;;AAEJ;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB","sourcesContent":[".chat-info-message {\r\n    box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);\r\n    border-radius: 4px;\r\n    max-width: 65%;\r\n    overflow-wrap: break-word;\r\n    padding: 10px 10px;\r\n    margin: 5px;\r\n    min-width: 100% !important;\r\n    height: auto;\r\n    background-color: rgba(185, 196, 196, 0.4);\r\n    font-size: 1.6rem;\r\n    margin-top: 2rem;\r\n    box-sizing: border-box;\r\n    min-height: 2rem;\r\n}\r\n\r\n.chat-info-message__flex-container {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 10px;\r\n    width: 100%;\r\n}\r\n\r\n.chat-info-message.chat-type-comment {\r\n    background-color: rgba(156, 247, 171, 0.4);\r\n}\r\n\r\n.chat-info-message.chat-type-group {\r\n    background-color: rgba(170, 156, 247, 0.4);\r\n}\r\n\r\n.chat-info-message.chat-type-mailing {\r\n    background-color: rgba(247, 218, 156, 0.4);\r\n}\r\n\r\nbutton.chat-info-message__chat-summary-button {\r\n    flex-shrink: 0;\r\n    font-size: 1.5rem;\r\n    gap: 1rem;\r\n    color: #039be5;\r\n    background-color: transparent;\r\n    display: flex;\r\n    align-items: center;\r\n    align-self: center;\r\n    white-space: nowrap;\r\n    position: static;\r\n    height: auto;\r\n    background: linear-gradient(90deg,rgba(227, 231, 231, 1) 70%, rgba(65, 180, 230, 0.14) 100%, rgba(227, 231, 231, 1) 100%);\r\n}\r\n\r\n    button.chat-info-message__chat-summary-button:focus {\r\n        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);\r\n        background-color: transparent;\r\n    }\r\n\r\n    button.chat-info-message__chat-summary-button:hover {\r\n        background: linear-gradient(90deg,rgba(227, 231, 231, 1) 70%, rgba(65, 181, 230, 0.24) 100%, rgba(227, 231, 231, 1) 100%);\r\n    }\r\n\r\n.summary-header-title-wrapper {\r\n    display: flex;\r\n    gap: 1.6rem;\r\n    align-items: center;\r\n}\r\n\r\n.summary-header__close-button-wrapper {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-wrap: nowrap;\r\n}\r\n\r\n    .summary-header__close-button-wrapper button {\r\n        margin-right: 1.8rem;\r\n    }\r\n\r\n.summary-modal.modal-dialog {\r\n    max-width: 65%;\r\n    min-width: 65%;\r\n    overflow: hidden;\r\n}\r\n\r\n.summary-modal .modal-title {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    font-weight: bold;\r\n    font-size: 3.6rem;\r\n}\r\n\r\n.summary-body__summary-text {\r\n    white-space: pre-line;\r\n    text-align: justify;\r\n}\r\n\r\n.summary-header-wrapper {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n    max-height: 15vh;\r\n}\r\n\r\n.summary-body-wrapper {\r\n    max-height: 65vh;\r\n    overflow-y: auto;\r\n    padding: 0 10px 0 0;\r\n}\r\n\r\n.summary-footer-wrapper {\r\n    max-height: 0;\r\n}\r\n\r\n.chat-info-message__content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex: 1 1 auto;\r\n    min-width: 0;\r\n}\r\n\r\n.chat-info-message__channel-row,\r\n.chat-info-message__chat-row {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 4px;\r\n    width: 100%;\r\n    min-width: 0;\r\n}\r\n\r\n.chat-info-message__channel-name {\r\n    max-width: 50rem;\r\n    min-width: 0;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    display: block;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
